import * as types from '@/store/mutationTypes';
import sessionManager from '@/store/modules/session/sessionManager';
import { isSupportMode, loadSupportMode, validateTargetSite } from './supportMode';

export async function bootstrapSupportSite(store, search = window.location.search) {
  const requested = new URLSearchParams(search).get('targetSite');
  const stored = sessionManager.getTargetSite();
  // Support mode only changes behaviour once a target is chosen, so plain loads skip the round trip.
  // An empty ?targetSite= still counts: it is how a target gets cleared.
  if (requested === null && !stored) return;

  await loadSupportMode();

  if (!isSupportMode()) {
    sessionManager.clearTargetSite();
    return;
  }

  store.commit(types.SESSION_SET_SUPPORT_MODE, true);

  const candidate = requested === null ? stored : requested;

  const target = candidate ? validateTargetSite(candidate) : null;
  // Role and app name cached for another tenant must not leak into this one.
  if (target !== stored) sessionManager.clearTenantScopedState();
  store.commit(types.SESSION_SET_TARGET_SITE, target);
}
